import React, { useState } from "react";
import { AiOutlineDelete } from "react-icons/ai"; // Import the delete icon
import Pagination from "./Pagination";
import { getUserData } from "../auth";
import { useGetWithdrawalQuery, useDeleteWithdrawalMutation } from "../apis/WithdrawalApi";

const WithdrawalRequestedList = () => {
  const [statusFilter, setStatusFilter] = useState('');
  const [dateFilter, setDateFilter] = useState('');

  const userData = getUserData();
  const userId = userData?.uid || ""; 

  // Fetch data with RTK Query
  const { data: sortedCarts = [], error, isLoading } = useGetWithdrawalQuery(userId, { pollingInterval: 5000 });
 // console.log('walletRequests:', walletRequests);
  const walletRequests  = sortedCarts? [...sortedCarts].sort((a, b) => b.id - a.id) : [];

  // Delete mutation
  const [deleteWithdrawal, { isLoading: isDeleting, isSuccess, isError, error: deleteError }] = useDeleteWithdrawalMutation();

  // Filter data based on status and validation date
  const filteredRequests = walletRequests.filter((request) => {
    const isStatusMatch = statusFilter ? request.status === statusFilter : true;
    const isDateMatch = dateFilter
      ? new Date(request.date).toLocaleDateString() === new Date(dateFilter).toLocaleDateString()
      : true;
    return isStatusMatch && isDateMatch;
  });

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3; // Number of items per page

  // Paginate data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentRequests = filteredRequests.slice(indexOfFirstItem, indexOfLastItem);

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Handle delete action
  const handleDelete = (requestId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this request?");
    if (confirmDelete) {
      // Call the delete mutation
      deleteWithdrawal(requestId);
    }
  };

  return (
    <section className="cart py-15">
      <div className="container container-lg">
        <div className="row gy-4">
        <div className='col-lg-11'>
        {/* Filters */}
            <div className="filters mb-4">
              <label>
                Status:
                <select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  className="ms-2"
                >
                  <option value="">All</option>
                  <option value="PENDING">PENDING</option>
                  <option value="APPROVED">APPROVED</option>
                </select>
              </label>

              <label className="ms-4">
                Validation Date:
                <input
                  type="date"
                  value={dateFilter}
                  onChange={(e) => setDateFilter(e.target.value)}
                  className="ms-2"
                />
              </label>
            </div>

            {/* Loading or Error State */}
            {isLoading && <div>Loading...</div>}
            {error && <div>Error fetching data</div>}

            {/* Deletion Process States */}
            {isDeleting && <div>Deleting...</div>}
            {isError && <div>Error deleting withdrawal: {deleteError.message}</div>}
            {isSuccess && <div>Withdrawal deleted successfully!</div>}

            {/* Table */}
            <div className="cart-table border border-gray-100 rounded-8 px-24 py-40">
              <div className="overflow-x-auto scroll-sm scroll-sm-horizontal">
                <table className="table style-three">
                  <thead>
                    <tr>        
                       <th className="h6 mb-0 text-lg fw-bold">Currency</th>
                       <th className="h6 mb-0 text-lg fw-bold">walletAddress</th>
                       <th className="h6 mb-0 text-lg fw-bold">Requested</th>
                       <th className="h6 mb-0 text-lg fw-bold">Old</th>
                      <th className="h6 mb-0 text-lg fw-bold">New</th>
                      <th className="h6 mb-0 text-lg fw-bold">Status</th>
                      <th className="h6 mb-0 text-lg fw-bold">Requested Date</th>
                      <th className="h6 mb-0 text-lg fw-bold">Validated</th>
                      <th className="h6 mb-0 text-lg fw-bold">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRequests.length > 0 ? (
                      currentRequests.map((request) => (
                        <tr key={request.id}> 
                           <td>{request.paymentMethod}</td>
                           <td>{request.walletAddress}</td>
                           <td>{request.amountRequested}</td>
                           <td>{request.oldBalance}</td>
                           <td>{request.newBalance}</td>
                           <td>
                             <span
                               className={`badge ${
                                 request.status === "PENDING"
                                   ? "bg-warning"
                                   : request.status === "APPROVED"
                                   ? "bg-success"
                                   : "bg-secondary"
                               }`}
                             >
                               {request.status || "N/A"}
                             </span>
                           </td>
                           <td>{new Date(request.dateRequested).toLocaleDateString()}</td>
                           <td>
                             {request.dateCompleted ? (
                               new Date(request.validateDateTime).toLocaleDateString()
                             ) : (
                               <span className="badge bg-warning">Pending</span>
                             )}
                           </td>
                           <td>
                             <AiOutlineDelete
                               className="text-danger cursor-pointer"
                               onClick={() => handleDelete(request.id)}
                               size={20}
                             />
                           </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">
                          No wallet requests found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Pagination Component */}
      <Pagination
        totalItems={filteredRequests.length}
        itemsPerPage={itemsPerPage}
        onPageChange={handlePageChange}
      />
    </section>
  );
};

export default WithdrawalRequestedList;
